module.exports = __webpack_public_path__ + "static/media/hot_zgxsc.ce3f6970.png";